import { DimensionSizing, DimensionUnit } from 'components/search/expedia/enums';
import { WidthState } from 'components/search/expedia/interfaces';

const initialWidthStates: Record<DimensionSizing, WidthState> = {
  [DimensionSizing.FIXED]: {
    widthSizing: DimensionSizing.FIXED,
    widthSize: 300,
    widthSizeMin: 250,
    widthSizeMax: 970,
    widthSizeStep: 1,
    widthUnit: DimensionUnit.FIXED,
  },
  [DimensionSizing.RELATIVE]: {
    widthSizing: DimensionSizing.RELATIVE,
    widthSize: 100,
    widthSizeMin: 0,
    widthSizeMax: 100,
    widthSizeStep: 0.1,
    widthUnit: DimensionUnit.RELATIVE,
  },
};

const initialFixedWidthState = initialWidthStates[DimensionSizing.FIXED];
const initialRelativeWidthState = initialWidthStates[DimensionSizing.RELATIVE];

export { initialWidthStates, initialFixedWidthState, initialRelativeWidthState };
